<template>
<transition name="fade" mode="out-in">
  <div class="page-container">
    <!--div class="backdrop"><div class="wave"></div></div-->
    <div class="content">
        <div class="module-cards-container">
            <router-link 
                v-on:click.native="handleModuleClick('a')" 
                :to="(moduleClick ? '' :'all_modules/advisory')" 
                :class="(!moduleClick ? '' : 'selected-card')"
                >
                <ModuleCard 
                    :class="(darken ? 'darken' : '')"
                    class="module-card module-card1"
                    title="Advisory"
                    path="/advisory"
                    :lessons="quizzes.advisory.length"
                    color="#2E4FA3"
                    :percentage="userRef.progress.advisory"
                    :show="a || !moduleClick || dashMod == 'a'" 
                    :darken="darken"
                />
            </router-link>
            <router-link 
                v-on:click.native="handleModuleClick('m')" 
                :to="(moduleClick ? '' :'all_modules/managed_services')" 
                :class="(!moduleClick ? '' : 'selected-card')"
                >
                <ModuleCard 
                    :class="(darken ? 'darken' : '')"
                    class="module-card module-card2"
                    title="Managed Services"
                    path="/managed_services"
                    :lessons="quizzes.managed_services.length"
                    color="#20356A"
                    :percentage="userRef.progress.managed_services"
                    :show="m || !moduleClick || dashMod == 'm'"
                    :darken="darken"
                />
            </router-link>
            <router-link 
                v-on:click.native="handleModuleClick('o')" 
                :to="(moduleClick ? '' :'all_modules/operations')" 
                :class="(!moduleClick ? '' : 'selected-card')"
                >
                <ModuleCard 
                    :class="(darken ? 'darken' : '')"
                    class="module-card module-card3"
                    title="Operations"
                    path="/operations"
                    :lessons="quizzes.operations.length"
                    color="#478A69"
                    :percentage="userRef.progress.operations"
                    :show="o || !moduleClick || dashMod == 'o'"
                    :darken="darken"
                />
            </router-link>
            <!-- <router-link 
                v-on:click.native="handleModuleClick('k')" 
                :to="(moduleClick ? '' :'all_modules/keno')" 
                :class="(!moduleClick ? '' : 'selected-card')"
                >
                <ModuleCard 
                    :class="(darken ? 'darken' : '')"
                    class="module-card module-card4"
                    title="Keno"
                    path="/keno"
                    :lessons="quizzes.keno.length"
                    color="#FFCC00"
                    :percentage="userRef.progress.keno"
                    :show="k || !moduleClick || dashMod == 'k'"
                    :darken="darken"
                />
            </router-link> -->
      </div>
    <router-view :claims="claims" :user="userRef" :quizzes="quizzes"></router-view>
    </div>
  </div>
</transition>
</template>

<script>
import firebase from "firebase";
import ModuleCard from '@/components/user_dash/ModuleCard';
import store from '../store';

export default {
  name: 'AllModules',
  components: {
      ModuleCard
  },
  data() {
      return {
            darken : false,
            clicked: false,
            m: false,
            a: false,
            o: false,
            k: false,
            user: null,
            quizzes: {
                advisory: [],
                managed_services: [],
                operations: [],
                keno: []
            },
            userRef: {
                progress: {
                    advisory: null,
                    managed_services: null,
                    operations: null,
                    keno: null
                },
                completed: []
            },
            claims: null
      };
  },
  created() {
    if(store.state.dashMod == '') {
        //console.clear();
        console.log('from dash');
        this.a = false;
        this.m = false;
        this.o = false;
        this.k = false;
    }
    else {
        //console.clear();
        console.log('not from dash');
        this.a = true;
        this.m = true;
        this.o = true;
        this.k = true;
    }
    var self = this;
    self.fetchUser();
  },
  mounted() {
      //this.fetchQuizzes();
  },
  computed: {
      moduleClick() {
          return store.state.moduleClick;
      },
      navClick() {
          return store.state.modulePage;
      },
      dashMod() {
          return store.state.dashMod;
      }
  },
  methods: {
    fetchUser() {
        var self = this;

        console.clear();

        firebase.auth().onAuthStateChanged((user) => {
            if(user) {
                console.log('user: ', user);
                self.claims = user;
                console.log('user: ', self.claims);
            } else {
                console.log('no user signed in');
            }

            self.bindData();
            self.fetchQuizzes();
        });
    },
    /*async setup() {
        console.log('setup jazz');
        this.claims = await this.$auth.getUser();
        console.log(this.claims);
        this.bindData();
    },*/
    /*async isAuthenticated() {
        this.authenticated = await this.$auth.isAuthenticated();
    },*/
    fetchQuizzes() {
        var self = this;

        firebase.firestore().collection("quizzes").get().then((docs) => {
            docs.forEach((doc) => {
                if(doc.data().module == 'Advisory') {
                    self.quizzes.advisory.push(doc.data());
                }
                else if(doc.data().module == 'Managed Services') {
                    self.quizzes.managed_services.push(doc.data());
                }
                else if(doc.data().module == 'Operations') {
                    self.quizzes.operations.push(doc.data());
                }
                else if(doc.data().module == 'Keno') {
                    self.quizzes.keno.push(doc.data());
                }
                else {
                    console.log('Unknown module');
                }
            });

            // ---------- filter quizzes ----------
            
            self.filterQuizzes(self.quizzes.advisory);
            self.filterQuizzes(self.quizzes.managed_services);
            self.filterQuizzes(self.quizzes.operations);
            self.filterQuizzes(self.quizzes.keno);

            //console.clear();
            console.log();
            //console.log(self.answerSheet);
            console.log();
            console.log('looks like we had what we needed all along: ');
            console.log();
            console.log('advisory length', self.quizzes.advisory.length);
            console.log('managed services length', self.quizzes.managed_services.length);
            console.log('operations length', self.quizzes.operations.length);
            console.log('keno', self.quizzes.keno.length);
            console.log('CONTEXT', this.$route.params.current);
            console.log();
            
        });
    },
    filterQuizzes(context) {
        const na = [...new Set(context)]; // set

        var sorted = [];
        var trash = [];
    
        na.forEach((item) => {
            if(!trash.includes(item.serviceLine)) {
                sorted.push({practiceGroup: item.practiceGroup, serviceLine: item.serviceLine, lessonID: item.lessonID});
                trash.push(item.serviceLine);
                //console.log(item.serviceLine);
            }
        });
        
        if(context == this.quizzes.advisory) { //advisory
            this.quizzes.advisory = sorted;
        }
        else if(context == this.quizzes.managed_services) { //managed_services
            this.quizzes.managed_services = sorted;
        }
        else if(context == this.quizzes.operations) { //operations
            this.quizzes.operations = sorted;
        }
        else { //keno
            this.quizzes.keno = sorted;
        }
    },
    bindData() {
        //console.clear();
        console.log('binding data..........', this.claims);
        var self = this;
        var fireRef = firebase.firestore().collection('users');
        fireRef.doc(self.claims.uid).get().then((doc) => {
            console.log('exists?: ', doc.exists);

            console.log('doc exists');
            console.log(doc.data());

            self.userRef.progress.advisory = doc.data().progress.advisory;
            self.userRef.progress.managed_services = doc.data().progress.managed_services;
            self.userRef.progress.operations = doc.data().progress.operations;
            self.userRef.progress.keno = doc.data().progress.keno;
            self.userRef.completed = doc.data().completed;

            console.log();
            console.log('just checking....... a: ', self.userRef.progress.advisory);
            console.log('just checking....... ms: ', self.userRef.progress.managed_services);
            console.log('just checking....... o: ', self.userRef.progress.operations);
            console.log('just checking....... k: ', self.userRef.progress.keno);
            console.log();
        });

        //console.log('data successfully binded.');
    },
    handleBack() {
        this.clicked = false;
        store.commit('modulePage');
    },
    toggleModules() {
        store.commit('moduleClick');
        this.darken = true;
    },
    handleModuleClick(title) {
        this.clicked = true;
        this.toggleModules();
        console.log('module clicked?: ' + this.moduleClick);
        console.log('nav clicked?: ' + this.navClick);
        if(title == 'm') {
            this.m = true;
            this.a = false;
            this.o = false;
            this.k = false;
            this.toggleModules;
        }
        else if(title == 'a') {
            this.a = true;
            this.m = false;
            this.o = false;
            this.k = false;
            this.toggleModules;
        }
        else if(title == 'o'){ 
            this.o = true;
            this.a = false;
            this.m = false;
            this.k = false;
            this.toggleModules;
        }
        else { //keno is clicked
            this.k = true;
            this.o = false;
            this.m = false;
            this.a = false;
            this.toggleModules;
        }
        store.commit('dashMod','');
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/global-styles/variables.scss';
.page-container {
    background: $colorBackdrop;
    a {
        text-decoration: none !important;
    }

    // width: 80%;
}

.backdrop {
    background: #f8f8f8;
    width: 100%;
    height: 40vh;
    position: absolute;
    bottom: 0px;
    z-index: -1;
    display: flex;
    justify-content: center;

    .wave {
        //background: green;
        width: 100vw;
        height: 200px;
        margin-top: -200px;
        background-image: url("../assets/wave.svg");
        background-size: contain;
        background-repeat: repeat-x;
        background-position-x: 600px;
        //animation: wave 3s ease forwards;    
    }
}

.content {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
.module-cards-container {
    //background: red;
    display: flex;
    transition: 3s;
    //justify-content: flex-start;
}
.module-card {
    opacity: 0;
    transition: 300ms;

    &:hover {
        .module-card-container {
            transform: scale(1.1) !important;
            box-shadow: $softerShadow !important;
        }
    }
}
.module-card1 {
    animation: flyup $pageTransitionSpeed ease forwards;
    //animation-delay: 0.2s;
}
.module-card2 {
    animation: flyup $pageTransitionSpeed ease forwards;
    animation-delay: 0.2s;
}
.module-card3 {
    animation: flyup $pageTransitionSpeed ease forwards;
    animation-delay: 0.4s;
}
.module-card4 {
    animation: flyup $pageTransitionSpeed ease forwards;
    animation-delay: 0.6s;
}
.selected-card {
    pointer-events: none;
    //margin: 16px;
}
.back-button {
    //background: red;
    cursor: pointer;
}
.darken {
    //filter: brightness(0.9);
}
</style>